import React from "react";
import TogglePushBtn from "../../../../components/Universal/TogglePushBtn.component";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import FilterBtn from "../../../../components/Universal/FilterBtn.component";
import "../../../../styles/Pages/Operational/Residential/Allotment/Allotment.style.css";

import { ReactComponent as PersonIcon } from "../../../../assets/Icons/Universal/Person.svg";
import { ReactComponent as PersonInMobileIcon } from "../../../../assets/Icons/Universal/PersonInMobile.svg";
import SearchIcon from "../../../../assets/Icons/Universal/Search.svg";
import Title from "../../../../components/Universal/Title.component";

import ProfileImg from "../../../../assets/Images/TestImg/profileImage.png";
import ProfileRedirectIcon from "../../../../assets/Icons/Universal/ProfileRedirectArrow.svg";

import ScrollableTable from "../../../../components/Universal/Tables/ScrollableTable.component";
import SecondModal from "../../../../components/Universal/SecondModal.component";
import RoundedImg from "../../../../components/Universal/RoundedImg.component";
import DeleteIcon from "../../../../assets/Icons/Universal/BinIcon.svg";
import EditAllotmentIcon from "../../../../assets/Icons/Universal/EditIcon.svg";
import ArrowRightIcon from "../../../../assets/Icons/Universal/ArrowRight.svg";
import AllotmentHistoryCard from "../../../../components/PagesComponents/Operational/Residential/Allotment/AllotmentHistoryCard.component";
import { Helmet } from "react-helmet";
const Body = ({
  filter,
  setFilter,
  classesFilter,
  setClassesFilter,
  changeDetails,
  setChangeDetails,
  handelDeleteAllotment,
  handelEditAllotment,
  deleteAllotment,
  deleteAllotmentState,
  allotmentHistory,
  setAllotmentHistory,
  //store states

  setlAllotmentId,
}) => {
  return (
    <div className="allotmentPage flex-col align-start justify-start g-1 pr-1">
      <Helmet>
        <title>Allotment</title>
      </Helmet>
      <PageHeader
        renderCustomElement={
          <div
            className="flex-row align-center justify-start g-05"
            style={{ flexWrap: "wrap" }}
          >
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="All"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Boys"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Girls"
            />
            <FilterBtn
              btnTitle={"Filter"}
              filterArray={[
                "Class I",
                "Class II",
                "Class III",
                "Class IV",
                "Class V",
              ]}
              setFilteredData={(val) => setClassesFilter(val)}
              filteredData={classesFilter}
            />

            <div className="flex-col g-05 align-start justify-end">
              <div className="searchInputContainer">
                <input
                  type="text"
                  className="pageHeaderInput"
                  placeholder="Type for search"
                />
                <button className="searchBtn">
                  <img src={SearchIcon} alt="searchBtn" />
                </button>
              </div>
            </div>
          </div>
        }
      />
      <SecondModal isCrossBtn isOpen={changeDetails} onClose={setChangeDetails}>
        <div className="flex-col align-center justify-start g-2 pt-2 pr-1">
          <Title className={"t-20"}>Change Details</Title>
          {/* profile card */}
          <div className="flex-row align-center justify-center g-1">
            <RoundedImg src={ProfileImg} width="4rem" height="4rem" />
            <div className="flex-col align-start justify-start">
              <h3 className="t-20 weight-500 color-black poppins">
                Md Rejuwanul Karim
              </h3>
              <span className="t-12 color-grayColor poppins">#SM0625356</span>
            </div>
          </div>
          {/* seat details */}
          <div className="w-full flex-col align-start justify-start g-1">
            <div className="w-full flex-row align-center justify-start g-05">
              <Title className={"color-black"}>Class:</Title>
              <Title style={{ color: "var(--greenColor)" }}>Class 5/A</Title>
            </div>
            <div className="w-full flex-row align-center justify-start g-05">
              <Title className={"color-black"}>Seat matrix code:</Title>
              <Title style={{ color: "var(--greenColor)" }}>H1G2603</Title>
            </div>
          </div>
          {/* details change actions */}
          <div className="flex-row align-center justify-center g-2 relative w-full pb-05 pt-1">
            <button
              type="button"
              className="transparentBtn deleteAllotmentBtn"
              onClick={(e) => handelDeleteAllotment(e, "_id")}
            >
              <span
                style={{
                  width: "100%",
                  height: "100%",
                  zIndex: "30",
                  position: "absolute",
                  left: "0",
                  top: "0",
                }}
              ></span>
              <img
                src={DeleteIcon}
                alt="delete btn"
                style={{ width: "1.8rem", height: "1.8rem" }}
              />
            </button>
            <button
              type="button"
              className="transparentBtn editAllotmentBtn"
              onClick={(e) => handelEditAllotment(e, "edit")}
            >
              <img
                src={EditAllotmentIcon}
                alt="edit Btn"
                style={{ width: "1.8rem", height: "1.8rem" }}
              />
            </button>
          </div>

          <div
            className="w-full flex-col align-start justify-start g-1 "
            style={{
              height: deleteAllotmentState ? "9.5rem" : 0,
              transition: ".5s",
              overflow: "hidden",
            }}
          >
            <hr style={{ width: "100%" }} />
            <div className="w-full flex-row align-center justify-between">
              <div className="flex-col align-start justify-start g-05">
                <div className="w-full flex-row align-center justify-start g-05">
                  <Title className={"color-black"}>Hostel: </Title>
                  <Title style={{ color: "var(--greenColor)" }}>H1</Title>
                </div>
                <div className="w-full flex-row align-center justify-start g-05">
                  <Title className={"color-black"}>Floor: </Title>
                  <Title style={{ color: "var(--greenColor)" }}>G</Title>
                </div>
                <div className="w-full flex-row align-center justify-start g-05">
                  <Title className={"color-black"}>Room: </Title>
                  <Title style={{ color: "var(--greenColor)" }}>26</Title>
                </div>
                <div className="w-full flex-row align-center justify-start g-05">
                  <Title className={"color-black"}>Seat: </Title>
                  <Title style={{ color: "var(--greenColor)" }}>03</Title>
                </div>
              </div>
              {/* remove btn */}
              <button
                type="button"
                className="transparentBtn radius-6 h-full pr-1 pl-1 flex-col align-center justify-center g-05"
                style={{ background: "var(--redColor)" }}
                onClick={() => deleteAllotment()}
              >
                <span className="color-white poppins t-16">Remove</span>
                <img src={ArrowRightIcon} alt="" />
              </button>
            </div>
          </div>
        </div>
      </SecondModal>
      <SecondModal
        isCrossBtn
        isOpen={allotmentHistory}
        onClose={setAllotmentHistory}
      >
        <div className="flex-col align-start justify-start g-2 pt-2 p-1">
          <Title className={"t-20 text-align-center bold"}>
            Allotment history
          </Title>
          {/* profile card */}
          <div className="flex-row align-center justify-center g-1">
            <RoundedImg src={ProfileImg} width="3.5rem" height="3.5rem" />
            <div className="flex-col align-start justify-start">
              <h3 className="t-20 weight-500 color-black poppins">
                Md Rejuwanul Karim
              </h3>
              <span className="t-12 color-grayColor poppins">#SM0625356</span>
            </div>
          </div>
          <div className="scroll-y pr-05" style={{ height: "30vh" }}>
            <div className="flex-col align-start justify-start g-1 ">
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
              <AllotmentHistoryCard
                class="class 5/A"
                seatMatrixCode={["H1G2603", "H1G2603"]}
              />
            </div>
          </div>
        </div>
      </SecondModal>
      <div
        className="flex-col align-start justify-start g-1 p-2 radius-13 back-white"
        style={{ height: "80vh" }}
      >
        <div className="flex-row align-center justify-start g-2">
          <div className="flex-row align-center justify-start">
            <Title className={"t-20"}>All alloted students list </Title>
            <Title className={"t-20"} style={{ color: "var(--greenColor)" }}>
              (1600)
            </Title>
          </div>
          <div className="toggleBtn">
            <label htmlFor="togglebtn-staffs">Stuffs list</label>
            <input type="checkbox" name="toggleStaffList" />
          </div>
        </div>

        <div className="studentDataTableContainer">
          <ScrollableTable
            thead={[
              "Name",
              "ID",
              "Class",
              "Allotment date",
              "Seat matrix code",
              "Action",
            ]}
            className={"hostelAllotmentListTable"}
          >
            {[...Array(10)].map((_) => (
              <tr>
                <td>
                  <div
                    className="flex-row align-center g-1"
                    style={{ position: "relative" }}
                  >
                    <img
                      src={ProfileImg}
                      alt="Profile"
                      style={{
                        width: "3.5rem",
                        height: "3.5rem",
                        borderRadius: "50%",
                      }}
                    />

                    <div className="flex-col align-start justify-start p-r-2">
                      <div
                        className="t-18 poppins text-align-left w-full"
                        style={{ color: "var(--textColor)" }}
                      >
                        Md Rejuwanul Karim
                      </div>
                      <div
                        className="t-13 poppins text-align-left w-full"
                        style={{ color: "var(--grayColor)" }}
                      >
                        Male
                      </div>
                    </div>
                  </div>
                  <button
                    style={{
                      width: "1rem",
                      height: "1rem",
                      position: "absolute",
                      top: "0.5rem",
                      right: "0.5rem",
                      background: "transparent",
                      border: "none",
                      outline: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setAllotmentHistory(true);
                      setlAllotmentId("jhg");
                    }}
                    // to={"/operational/academic/students/profile"}
                  >
                    <img
                      src={ProfileRedirectIcon}
                      alt="Profile"
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </button>
                </td>
                <td>MSMSjhg555</td>
                <td>Vii</td>
                <td>
                  <Title style={{ fontSize: "13px" }} className={"color-black"}>
                    10/12/2025
                  </Title>
                </td>
                <td>000000</td>
                <td>
                  <div>
                    <button
                      className="blueActionBtn radius-6 color-white"
                      style={{
                        borderRadius: "6px",
                        background: "var(--blueColor1)",
                        color: "var(--whiteText)",
                      }}
                      onClick={() => setChangeDetails(true)}
                    >
                      Change details
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </ScrollableTable>
        </div>
      </div>
    </div>
  );
};

export default Body;
